import React, { useState } from "react";
import "../../../StyleSheet/MainComponent/LoginPage/LoginPage.scss";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import Password from "../../AppComponent/InputFields/Password";
import validator from "validator";
import { useDispatch } from "react-redux";
import { getUserAction } from "../../../Redux/Slice";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import data from "../../../Context/Json/Language/English";
import { useNavigate } from "react-router-dom";

const LoginPage = (props) => {
  const EnglishData = data;
  const Datas = {
    email: "",
    Password: "",
  };
  const [InputData, setInputDatas] = useState(Datas);
  const [EmailError, setEmailError] = useState("");
  const navigate = useNavigate();

  const [PasswordError, setPasswordError] = useState("");
  // const [isvalid, setvalid] = useState(true);
  // const [validateType, setValidatetype] = useState(null);
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();
    var a = 0;
    if (!validator.isEmail(InputData.email)) {
      setEmailError("*Enter valid mail id");
      a = 1;
    }

    if (validator.isEmpty(InputData.Password)) {
      setPasswordError("*password is required");
      a = 1;
    }

    if (a === 0) {
      dispatch(getUserAction(InputData));
    }
  };

  return (
    <>
      <div className="uds-loginpage ">
        <div className=" row Conatiningpart">
          <div className="col-md-6 Welcomepart">
            <div className="Toppart">
              <img className="desingimg" src={toppart} alt="bgImage" />
            </div>
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                <div className="Content">
                  <h1>Welcome</h1>
                </div>
                {/* {EnglishData.LeftSide.Content.Content.map((item) => ( */}
                <p>Sign in to continue</p>
                {/* ))} */}
                {EnglishData.LeftSide.Content2.map((item) => (
                  <div className="para">
                    {/* <p>{item.para2}</p> */}
                    <p>
                      {/* <strong>UDS :&nbsp;</strong> */}
                      Experience the future of business services with UDS.
                      Revolutionizing India's service landscape, we offer
                      integrated solutions for diverse sectors like never
                      before. From FMCG giants to cutting-edge IT firms, we've
                      got you covered.
                      {/* Your one-stop solution for
                      integrated business services across India. From facilities
                      management to diverse sector needs including FMCG,
                      healthcare, IT, logistics, and more. */}
                    </p>
                  </div>
                ))}

                {/* --------Details-------------------- */}
                <div className="Details">
                  {EnglishData.LeftSide.Details.Detail1.map((item) => (
                    <p key={item.id}>Enter Your Details</p>
                  ))}
                  <div className="Arrow">
                    <img src={Arrow} alt="bgArrow" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 loginpart">
            <div className="Loginwrapped">
              <div className="Udslog">
                {EnglishData.LeftSide.LoginPages.map((item) => (
                  <h4 className="heading" key={item.id}>
                    {/* {item.LoginHead} */}
                    Login in to UDS
                  </h4>
                ))}
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="Input-Inner">
                    {/* {EnglishData.LeftSide.InputLabel.map((item) => ( */}
                    <>
                      <Email
                        value={InputData.email}
                        onChange={(e) => {
                          setEmailError("");
                          HandleChanges(e);
                        }}
                        Error={EmailError}
                        label="Email"
                        type={"text"}
                        //   isvalid={isvalid}
                        //   validateType={validateType}
                      />
                      <Password
                        value={InputData.Password}
                        onChange={(e) => {
                          setPasswordError("");
                          HandleChanges(e);
                        }}
                        Error={PasswordError}
                        label="Password"
                      />
                    </>
                    <span className="fortgotPassword">
                      <a
                        onClick={() => {
                          navigate("/forgotpassword");
                        }}
                      >
                        Forgot Password ?
                      </a>
                    </span>
                  </div>
                  <div className="SubmitButton">
                    {EnglishData.LeftSide.Button.Button1.map((item) => (
                      <CustomButton
                        children="Submit"
                        //   onClick={handleSubmit}
                        type="submit"
                      >
                        {item.ButtonName}
                      </CustomButton>
                    ))}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
